/* global _ */

import getCustomLogger from './modules/logger';
import ApuracaoPanoramaBase from './apuracao-panorama-base';
import './vendor/lodash.custom.min';

import { nodeListToArray, abrangenciaIsValid, getSemanticKey } from './utils';

const logger = getCustomLogger('Widget Apuracao Base');

class WidgetApuracaoBase {
  constructor(options) {
    this.object = {};
    this.object.options = options;
    this.object.options.apuracoesAbrangencias = [];
    this.object.options.error = this.jsonErrorCallback;

    this.abrangenciaSelector = '.js-widget-apuracao';
    this.abrangenciaGeoLocalizadaSelector = '.js-widget-apuracao-geolocalizada';

    return this.init();
  }

  inicializaApuracao(abrangenciaEl) {
    var options = {
      highPriority: false,
    };
    Object.assign(options, this.object.options);

    /* this.object.options possui chave container. Quando container é o widget, da erro ao obter url do json */
    options.container = abrangenciaEl;
    return new ApuracaoPanoramaBase(options);
  }

  inicializaApuracoes() {
    const abrangenciasElements = this.object.options.container.querySelectorAll(
      `${this.abrangenciaSelector}:not(${this.abrangenciaGeoLocalizadaSelector})`
    );

    if (this.object.options.panorama) {
      this.inicializaApuracao(abrangenciasElements);
    } else {
      // Maybe this conditional can be removed
      this.object.apuracoesAbrangencias = nodeListToArray(abrangenciasElements).map((abrangenciaEl) => {
        return this.inicializaApuracao(abrangenciaEl);
      });
    }
  }

  inicializaAbrangenciaGeolocalizada(callback) {
    callback = callback || function () {};

    const abrangenciaEl = this.object.options.container.querySelector(this.abrangenciaGeoLocalizadaSelector);

    if (abrangenciaEl) {
      window.glb.local
        .getLocation({
          success: (data) => {
            if (abrangenciaIsValid(data)) {
              this.adicionaInformacoesDeAbrangenciaGeolocalizada(abrangenciaEl, data);
              this.inicializaApuracao(abrangenciaEl);

              const selector = getSemanticKey(this.object.options.isEstadual, data);
              this.escondeAbrangenciaDuplicada(selector.toLowerCase());
            } else {
              abrangenciaEl.remove();
            }
          },
          error: function (e) {
            logger.log('glb.local error: ', e);
            abrangenciaEl.remove();
          },
        })
        .catch((err) => {
          logger.log('Ocorreu um erro em inicializaAbrangenciaGeolocalizada() ', err);
        })
        .then(callback);
    } else {
      logger.warn(`Apuration Geolocated container with class ${this.abrangenciaGeoLocalizadaSelector} not found.`);
      callback();
    }
  }

  escondeAbrangenciaDuplicada(selector) {
    let abrangenciaEl = this.object.options.container.querySelector(
      this.abrangenciaSelector + '[data-key="' + selector + '"]'
    );

    // Remove abrangencia from another container, like Central da Apuracao page
    if (!abrangenciaEl) {
      abrangenciaEl = document.querySelector(this.abrangenciaSelector + '[data-key="' + selector + '"]');
    }

    if (abrangenciaEl) {
      if (this.object.apuracoesAbrangencias) {
        // Maybe this conditional can be removed
        let apuracaoDuplicada = this.object.apuracoesAbrangencias.find((apuracao) => {
          return apuracao.options.container === abrangenciaEl;
        });
        apuracaoDuplicada.turnOffPolling();
      }
      abrangenciaEl.remove();
    }
  }

  adicionaInformacoesDeAbrangenciaGeolocalizada(abrangenciaEl, data) {
    let payload = {
      city: data.semantic.city,
      state: data.semantic.state,
      region: data.semantic.region,
      year: this.object.options.ano,
      turno: this.object.options.turno,
      name: this.object.options.isEstadual ? data.state.name : `${data.city.name}, ${data.state.code}`,
      key: getSemanticKey(this.object.options.isEstadual, data),
    };

    try {
      this.adicionaInformacoesDeAbrangencia(
        abrangenciaEl,
        _.template(this.object.options.urlTemplatePaginaApuracao)(payload),
        _.template(this.object.options.urlTemplateJsonApuracao)(payload),
        payload
      );
    } catch (err) {
      logger.error('Erro ao adicionaInformacoesDeAbrangencia(): ', err);
    }
  }

  adicionaInformacoesDeAbrangencia(abrangenciaEl, urlApuracao, urlJsonApuracao, payload) {
    const headerEl = abrangenciaEl.querySelector('.js-widget-apuracao-abrangencia-nome');
    const link_title = `Ver apuração completa de ${payload.name}`;

    abrangenciaEl.dataset['key'] = payload.key.toLowerCase();
    abrangenciaEl.dataset['urlJsonApuracao'] = urlJsonApuracao.replace('/http://', '/');

    nodeListToArray(headerEl.childNodes).forEach(function (item) {
      if (item.nodeName === '#text') {
        headerEl.removeChild(item);
      }
    });

    headerEl.appendChild(document.createTextNode(payload.name));
    abrangenciaEl.setAttribute('title', link_title);
    abrangenciaEl.setAttribute('href', urlApuracao);
  }

  jsonErrorCallback() {
    if (this.containerEl.length === 1) {
      this.containerEl[0].remove();
      this.turnOffPolling();
    } else {
      logger.log('Ocorreu um erro ao tentar obter dados de panorama.');
    }
  }

  init() {
    if (this.object.options.hasGeolocalizado) {
      this.inicializaAbrangenciaGeolocalizada(this.inicializaApuracoes.bind(this));
    } else {
      this.inicializaApuracoes();
    }
    return this.object;
  }
}

export default WidgetApuracaoBase;
